import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeries } from './op-chart-series'
import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'


export class OpChartControl extends OpDashboardControl {
    //Properties
    public title: OpDescr
    public seriesList: OpChartSeries[]
    public isTableVisible: boolean
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            if (opObj.Title)
                this.title = new OpDescr(opObj.Title)
            if (opObj.SeriesList)
                this.seriesList = opObj.SeriesList.map(data => new OpChartSeries(data))
            this.isTableVisible = opObj.IsTableVisible
        }
        if (!this.seriesList)
            this.seriesList = []
    }
}